const copyToClipboard = async (text, callback) => {
  try {
    await navigator.clipboard.writeText(text);
    callback();
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
};

export default copyToClipboard;
